{/* Auto-generated icon - do not edit */}
import React from 'react'

interface UserMaleIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number | string
}

export const UserMaleIcon = React.forwardRef<SVGSVGElement, UserMaleIconProps>(
  ({ size = 24, color = "currentColor", ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 154 139"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        
<g clip-path="url(#clip0)">
<path d="M76.6855 71.5615C65.6857 70.9757 55.8861 69.1054 47.7116 62.3051C41.7686 57.3606 38.2463 50.9588 36.7987 43.4632C33.6317 27.0857 42.6463 12.8772 56.1894 5.89224C65.6228 1.0266 75.5581 -0.855128 86.1177 0.77602C95.1291 2.16731 101.72 7.2487 107.058 14.2679C108.865 16.6451 110.987 18.9033 112.244 21.5559C114.841 27.0416 117.049 32.6689 115.551 39.0629C114.148 45.0425 112.412 50.8119 108.506 55.6989C101.648 64.2794 92.9826 69.7286 81.8758 70.9402C79.8933 71.1555 77.9212 71.4128 76.6855 71.5615ZM46.4202 39.9973C47.6111 48.8674 52.006 55.2204 60.2239 58.5021C63.5488 59.7191 67.0069 60.538 70.5253 60.941C81.8888 62.547 91.6425 59.6001 98.8685 50.236C102.12 46.2124 103.704 41.0997 103.295 35.9481C94.099 34.2445 85.7793 31.1639 79.0382 24.457C70.3509 34.3228 58.8442 37.9304 46.4181 39.9973H46.4202Z" fill={color}/>
<path d="M95.7339 137.907C81.8738 137.907 68.013 137.836 54.1544 137.928C42.1912 138.007 30.2319 138.35 18.2669 138.403C14.9469 138.425 11.6336 138.098 8.38211 137.429C2.30359 136.153 0.343106 132.725 1.87245 126.697C3.08673 121.913 5.56776 117.71 8.18172 113.601C18.7984 96.8872 33.9953 85.9476 52.2918 78.9375C62.2227 75.0506 72.7768 72.9883 83.444 72.8493C98.8963 72.7342 113.246 76.4697 125.57 86.4402C134.336 93.4348 141.524 102.193 146.667 112.145C148.186 115.095 149.811 118.012 151.039 121.082C152.127 123.729 152.905 126.492 153.359 129.317C154.013 133.713 151.627 136.648 147.246 137.176C144.173 137.575 141.079 137.797 137.979 137.84C123.898 137.91 109.816 137.871 95.7339 137.871V137.907ZM142.397 127.433C142.448 126.851 142.543 126.609 142.475 126.426C137.953 114.457 131.542 103.723 121.671 95.3336C115.882 90.4143 109.494 86.4861 102.035 84.5505C92.1086 82.062 81.7668 81.6935 71.6876 83.4695C46.6982 87.5845 26.735 99.7092 13.1076 121.389C11.658 123.695 10.5034 126.188 9.13486 128.735C13.6821 130.051 17.8222 129.526 22.0271 129.272C30.2015 128.779 38.4038 128.6 46.5978 128.555C72.3204 128.416 98.0445 128.432 123.767 128.31C129.522 128.283 135.275 127.94 141.028 127.725C141.492 127.664 141.95 127.566 142.397 127.431V127.433Z" fill={color}/>
</g>
<defs>
<clipPath id="clip0">
<rect width="153" height="139" fill={color} transform="translate(0.777344)"/>
</clipPath>
</defs>

      </svg>
    )
  }
)

UserMaleIcon.displayName = 'UserMaleIcon'
